module.exports = __webpack_public_path__ + "img/hands.004fdc5.png";